const productList = window.shopifySuggestrator;

document.addEventListener('DOMContentLoaded', function () {

    let mapper = [
        {
            step: 0,
            type: "Type de logement",
            question: "Quel genre d’habitation avez-vous ?",
            answers: [
                { label: "Maison", value: "house", icon: iconPaths.house },
                { label: "Appartement", value: "building", icon: iconPaths.building }
            ],
            value: ""
        },
        {
            step: 1,
            type: "Information sur le logement",
            question: {
                house: "Combien de portes d’entrée avez-vous ?",
                building: "Habitez-vous au rez-de-chaussée ?"
            },
            answers: {
                house: [
                    { label: 1, value: 1 },
                    { label: 2, value: 2 },
                    { label: 3, value: 3 },
                      { label: 4, value: 4 },
                ],
                building: [
                    { label: "Oui", value: "yes" },
                    { label: "Non", value: "no" },
                ]
            },
            value: "",
            product: productList.find(e => e.text == "porte-connecte")?.product,
            selectProduct: null
        },
        {
            step: 2,
            type: "Information sur le logement",
            question: "Combien de fenêtres compte votre logement ?",
            answers: [

            ],
            value: 1,
            product: productList.find(e => e.text == "fenetres-connectes")?.product,
            selectProduct: null
        },
        {
            step: 3,
            type: "Information sur le logement",
            question: "Quelle est la surface habitable de votre logement ?",
            answers: [

            ],
            value: 10,
            product: productList.find(e => e.text == "securite")?.product,
            match: {
                50: 1,
                100: 2,
                150: 3
            },
            selectProduct: null
        },
    ];


    const stepper_suggestrator = document.getElementById('stepper_suggestrator');
    const start_suggestrator = document.getElementById('start_suggestrator');
    const breadcrumb_suggestrator = document.getElementById('breadcrumb_suggestrator');
    const container_suggestrator = document.getElementById('container_suggestrator')

    let step = 0;

    const initApp = {
        getMatchedFromMapper: () => {
            const { value, match } = mapper[3];
            const numericValue = parseInt(value, 10);

            const keys = Object.keys(match).map(Number).sort((a, b) => a - b);
            for (let i = 0; i < keys.length; i++) {
                if (numericValue <= keys[i]) {
                    return match[keys[i]];
                }
            }
            return match[keys[keys.length - 1]];
        },
        zonePagination: (prev = true, next = true) => {
            let html = `<div class="pagination-suggestrator">`
            if (prev) {
                html += `<button id="page_prev" class="item-page-suggestrator prev">Précédent</button>`
            }
            if (next) {
                html += ` <button id="page_next" class="item-page-suggestrator next">Suivant</button>`
            }
            html += `</div>`
            return html;
        },
        zoneListenerPagination: (value_prev, value_next) => {
            const button_prev = document.getElementById('page_prev');
            const button_next = document.getElementById('page_next');
            if (button_prev && value_prev) {
                button_prev.addEventListener('click', value_prev);
            }

            if (button_next && value_next) {
                button_next.addEventListener('click', value_next);
            }
        },
        zoneText: (q, a, callBack, prev = true, next = true) => {
            // Construire la question
            let html = `<h2 class="title-q-sussgestrator">${q}</h2>`;

            // Ajouter les réponses (boutons par exemple)
            html += `<div class="answer-zone ${a == 'number' ? "number-zone" : ""} ${a == 'typing' ? "typing" : ""}  ">`;
            if (typeof a == "object") {
                a.forEach(answer => {
                    html += `
                         <button 
                             type="button" 
                             data-value="${answer.value}"
                             class="answer-btn"
                         >  `
                    if (answer.icon) {
                        html += `<img class="icon-answer" src="${answer.icon}" alt="icone ${answer.label}" />`
                    }
                    html += `
                             ${answer.label}
                         </button>
                     `;
                });
                html += '</div>';
                html += initApp.zonePagination(prev, next);

                // Injecter dans le DOM
                stepper_suggestrator.innerHTML = html;
                setTimeout(() => {
                    document.querySelectorAll('.answer-btn').forEach(btn => {
                        btn.addEventListener('click', (e) => {
                            const selectedValue = e.target.dataset.value;
                            callBack(selectedValue)

                        });
                    });
                }, 100);
            } else if (a == "number") {

                html += `
                     <div class="quantity-selector">
                            <button type="button" id="qty-decrease">-</button>
                            <input
                                type="number"
                                name="quantity"
                                id="quantity-input"
                                min="1"
                                value="1"
                                style="text-align: center;"
                            >
                            <button type="button" id="qty-increase">+</button>
                        </div>
                    </div>`;
                html += initApp.zonePagination(prev, next);
                stepper_suggestrator.innerHTML = html;
                setTimeout(() => {
                    document.getElementById('qty-decrease').addEventListener('click', (e) => {
                        callBack("-")
                    })
                    document.getElementById('qty-increase').addEventListener('click', (e) => {
                        callBack("+")
                    })
                }, 100);
            } else if (a == "typing") {
                html += `
                    <div class="quantity-selector str-num-qut-selc" style="display: flex; align-items: center;">               
                       <input
                           type="number"
                           name="quantity"
                           id="quantity-typing"
                           min="10"
                           value="10"
                       >
                       <p class="mettre-carre">m2</p>
                    </div>
               </div>`;
                html += initApp.zonePagination(prev, next);
                stepper_suggestrator.innerHTML = html;
                setTimeout(() => {
                    const typingClick = document.getElementById('quantity-typing')
                    if(typingClick){
                        typingClick.addEventListener('change', (e) => {
                            callBack(e.currentTarget.value)
                        })
                    }
                }, 100);
            }
        },
        sortVariantsByPriceAndInventory: (variants) => {
            const trimVriants = variants.sort((a, b) => {
                const priceA = parseFloat(a.price);
                const priceB = parseFloat(b.price);

                if (priceA < priceB) return -1;
                if (priceA > priceB) return 1;

                // Prix identiques → trier par stock décroissant
                return b.price - a.price;
            });
            if (trimVriants?.length > 0) {
                return trimVriants[0];
            }
            return null
        },
        calculPercentProgress: (indexMap) => {
            const total = mapper.length;
            if (total === 0) return "0%"; // éviter division par zéro
            const percent = ((indexMap - 1) / (total - 1)) * 100;
            return `${percent}%`;
        },
        breadcrumgInit: () => {
            if (breadcrumb_suggestrator) {
                let html = `
                <div id="block-cta-back" class="suggestrator-cta-back">
                    <button class="btn-back-suggestrator target-btn-back-suggestrator">
                    <img src="${iconPaths.iconBack}" style="width:20px;height:20px;object-fit:contain"></img>
                    <span class="back-txt-suggestrator">
                    Recommencer
                    </span>
                    </button>
                    <p class="text-info-suggestrator center-text-absolute">Le résultat de votre simulation</p>
                </div>
                <p id="title-suggestrator-main" class="text-info-suggestrator">
                    Étape <span class="" id="target-index-suggestrator">1</span>
                    <span class="t-grey">/ ${mapper.length} :</span> <span class="t-grey" id="target-type-suggestrator">${mapper[0].type}</span>
                    
                    </p>
                    <div class="container-progress-suggestrator">
                        <div style="width:${initApp.calculPercentProgress(1)}" id="target-progress-suessgtrator" class="line-progress-suggestrator"></div>
                    </div>
                `;
                breadcrumb_suggestrator.innerHTML = html;
            }
        },
        breadcrumbDOM: (index) => {
            const type = mapper[index - 1].type;
            const percent = initApp.calculPercentProgress(index);
            const targetIndex = document.getElementById('target-index-suggestrator');
            const targetType = document.getElementById('target-type-suggestrator');
            const targetPercent = document.getElementById('target-progress-suessgtrator');


            if (targetIndex && targetType && targetPercent) {
                targetIndex.innerText = index;
                targetType.innerText = type;
                targetPercent.style.width = percent;
            }

        },
        step1: () => {
            stepper_suggestrator.classList.add('step')
            const currentStep = mapper[step];
            if (currentStep) {
                initApp.zoneText(currentStep.question, currentStep.answers, (selectedValue) => {
                    // Ajouter un gestionnaire si besoin (ex : click sur une réponse)
                    mapper[step].value = selectedValue;
                    step = 1
                    initApp.step2()
                }, false, false)
            }
            initApp.breadcrumbDOM(1)
        },
        step2: () => {
            const currentStep = mapper[step];
            const prevStepMapper = mapper[0]
            const question = currentStep.question[prevStepMapper.value]
            const answers = currentStep.answers[prevStepMapper.value];

            initApp.zoneText(question, answers, (selectedValue) => {
                mapper[step].value = selectedValue;
                step = 2;
                initApp.step3();
            }, true, false)
            initApp.zoneListenerPagination(() => {
                step = 0;
                initApp.step1();
            }, null)
            initApp.breadcrumbDOM(2)
        },
        step3: () => {
            const currentStep = mapper[step];
            const prevStepMapper = mapper[1]
            /** MAISON APPARTMENT (RDC) */
            if (prevStepMapper.value !== "no") {
                const question = currentStep.question
                initApp.zoneText(question, "number", (sign) => {
                    if (sign == "-") {
                        mapper[step].value--;
                        document.getElementById('quantity-input').value = mapper[step].value;
                    } else if (sign == '+') {
                        mapper[step].value++;
                        document.getElementById('quantity-input').value = mapper[step].value;
                    }
                }, true, true)
                initApp.breadcrumbDOM(3)
                document.getElementById('quantity-input').value = mapper[step].value
            } else {
                mapper[2].value = 0;
                step = 3;
                initApp.step4()

            }
            initApp.zoneListenerPagination(() => {
                step = 1;
                initApp.step2();
            }, () => {
                step = step+1
                initApp.step4()
            })

        },
        step4: () => {
            const currentStep = mapper[step];
            const question = currentStep?.question
            initApp.zoneText(question, "typing", (value) => {
                mapper[step].value = value;
            }, true, true)
            initApp.zoneListenerPagination(() => {
                step = 2;
                initApp.step3();
            }, () => {
                initApp.finish()
            })
            const value_4 = document.getElementById('quantity-typing')
            if(value_4){
                value_4.value = mapper[step].value;
            }
            initApp.breadcrumbDOM(4)
        },
        restartSuggestrator: () => {
            const targetBtnBack = document.querySelectorAll('.target-btn-back-suggestrator');
            if (targetBtnBack?.length > 0) {
                targetBtnBack.forEach(e => {
                    e.addEventListener('click', () => {
                        step = 0;
                        mapper[0].value = "";

                        mapper[1].value = "";
                        mapper[1].selectProduct = null;

                        mapper[2].value = 1;
                        mapper[2].selectProduct = null;

                        mapper[3].value = 10;
                        mapper[3].selectProduct = null;

                        if (container_suggestrator) {
                            container_suggestrator.classList.remove('hide-side')
                        }
                        initApp.step1()
                        initApp.breadcrumgInit();
                         initApp.restartSuggestrator()

                    })
                })
            }
        },
        finishTotalCalcul: () => {
            const doorPrice = (mapper[1].selectProduct.qty * mapper[1].selectProduct.price) || 0;
            const windowPrice = (mapper[2].selectProduct.qty * mapper[2].selectProduct.price) || 0;
            const surfacePrice = (mapper[3].selectProduct.qty * mapper[3].selectProduct.price) || 0;
            const prix = doorPrice + windowPrice + surfacePrice;
            if (Number.isInteger(prix)) {
                return prix.toString();
            }
            return prix.toFixed(2);
        },
        finish: () => {

            /** PORTE */
            const qtyDoor = mapper[0].value == "building" ? 1 : mapper[1].value;
            const qtyWindow = mapper[2].value;
            const qtyDetect = initApp.getMatchedFromMapper();
            const totalProduct = parseInt(qtyDoor) + parseInt(qtyWindow) + parseInt(qtyDetect)

            if (container_suggestrator) {
                container_suggestrator.classList.add('hide-side')
            }

            /** PRODUCT */
            let productsInfo = [];

            /** DOOR */
            const productsDoor = mapper[1].product

            if (productsDoor) {
                const doorSelect = {
                    ...productsDoor,
                    label: "Détecteur d'ouverture et fermeture porte",
                    qty: qtyDoor
                }
                productsInfo.push(doorSelect)
                mapper[1].selectProduct = doorSelect
            }
            /** WINDOW */
            const productsWindow = mapper[2].product;
            if (productsWindow) {
                const windowSelect = {
                    ...productsWindow,
                    label: "Détecteur d'ouverture et fermeture fenêtre",
                    qty: qtyWindow
                }
                productsInfo.push(windowSelect)
                mapper[2].selectProduct = windowSelect

            }

            /** DETECTOR */
            const handleDetector = mapper[3].product;
            if (handleDetector) {

                const captorSelect = {
                    ...handleDetector,
                    label: "Capteur de mouvement",
                    qty: qtyDetect
                }
                productsInfo.push(captorSelect)
                mapper[3].selectProduct = captorSelect

            }



            /** RESULT */
            let html = `
            <div class="finish">
                <div class="main-list-finish">
                    <p class="titre-finish">Listes des produits</p>
                    <p class="">${totalProduct} produit${totalProduct > 1 ? "s" : ""}</p>
                    <div class="list-items-finish">
            `
            productsInfo.forEach(e => {
                html += `
                <div class="item-finish">
                    <img class="img-item-finish" src="${e.image}" alt="${e.title}" />
                    <div class="item-info-finish">
                        <p>${e.label}</p>
                        <p>${e.price}€</p>
                        <div class="quantity-selector" style="display: flex; align-items: center;">
                                <button type="button" class="qty-item-decrease">-</button>
                                <input
                                    type="number"
                                    name="quantity"
                                    id="quantity-input"
                                    min="1"
                                    value="${e.qty}"
                                    style="width: 50px; text-align: center;"
                                >
                                <button type="button" class="qty-item-increase">+</button>
                        </div>
                
                    </div>
                </div>
                `
            })
            html += `</div>`
            html += `</div>
                <div class="result-finish">
                    <div class="line-total">
                        <p class="titre-finish">Total</p>
                        <p class="text-finish-price">${initApp.finishTotalCalcul()}€</p>
                      
                    </div>
                    <button class="btn-square" id="btn-cart-suggestrator">Ajouter au panier</button>
                </div>
            `
            html += `</div>`
            stepper_suggestrator.innerHTML = html;
        }
    }


    if (stepper_suggestrator) {
        initApp.step1()
        initApp.breadcrumgInit();
        initApp.restartSuggestrator()
    }
    if (start_suggestrator) {
        start_suggestrator.addEventListener('click', () => {

        });

    }
})
